// Viaggio dimostrativo per preview mode e screenshot della landing.
// Interamente fittizio: nessun dato reale, nessuna chiamata API.

export const DEMO_TRIP_ID = 'demo';

const maps = q => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

export function buildDemoTrip(lang = 'it') {
    const tr = (it, en) => (lang === 'en' ? en : it);

    return {
        id: DEMO_TRIP_ID,
        name: tr('Portogallo con gli amici', 'Portugal with friends'),
        destination: 'Lisboa, Sintra, Porto',
        startDate: '2027-05-12',
        endDate: '2027-05-17',
        image: '🚋',
        currency: '€',
        budget: 650,
        cities: [
            {
                name: 'Lisboa',
                hotel: {
                    name: 'Casa Alfama Guesthouse',
                    address: 'Alfama, Lisboa',
                    rating: 4.6,
                    price: 92,
                    notes: tr('Camera quadrupla, colazione inclusa', 'Room for four, breakfast included'),
                    mapsLink: maps('Alfama Lisboa'),
                },
                days: [
                    {
                        date: '2027-05-12',
                        activities: [
                            { time: '10:40', timeS: '10:40', timeE: '11:10', type: 'transport', name: tr('Aeroporto → Alfama in metro', 'Airport → Alfama by metro'), from: 'Aeroporto Humberto Delgado', to: 'Santa Apolónia', distance: 9, cost: 2, notes: tr('Linea rossa, cambio ad Alameda', 'Red line, change at Alameda') },
                            { time: '12:00', type: 'check-in', name: tr('Check-in e deposito bagagli', 'Check-in and luggage drop'), cost: 0 },
                            { time: '15:00', type: 'activity', name: 'Castelo de São Jorge', cost: 15, notes: tr('Tramonto dal Miradouro da Graça subito dopo', 'Sunset at Miradouro da Graça right after'), link: 'https://castelodesaojorge.pt/' },
                            { time: '20:30', type: 'food', name: tr('Cena con fado in Alfama', 'Dinner with fado in Alfama'), cost: 35, notes: tr('Prenotare per 4, chiedere tavolo vicino al palco', 'Book for 4, ask for a table near the stage') },
                        ],
                    },
                    {
                        date: '2027-05-13',
                        activities: [
                            { time: '09:00', timeS: '09:00', timeE: '09:30', type: 'transport', name: tr('Tram 15E per Belém', 'Tram 15E to Belém'), from: 'Praça da Figueira', to: 'Belém', distance: 7, cost: 3 },
                            { time: '09:45', type: 'activity', name: 'Mosteiro dos Jerónimos', cost: 12, notes: tr('Biglietti online, entrata alle 10', 'Tickets online, entry at 10am') },
                            { time: '11:30', type: 'food', name: 'Pastéis de Belém', cost: 6, notes: tr('Coda veloce al banco da asporto', 'The take-away queue moves fast') },
                            { time: '13:00', type: 'activity', name: 'Torre de Belém', cost: 8 },
                            { time: '16:30', type: 'shopping', name: 'LX Factory', cost: 0, notes: tr('Libreria Ler Devagar', 'Ler Devagar bookshop') },
                        ],
                    },
                    {
                        date: '2027-05-14',
                        activities: [
                            { time: '10:00', type: 'activity', name: 'Oceanário de Lisboa', cost: 25, multipleOption: 'A', notes: tr('Se piove', 'If it rains') },
                            { time: '10:00', type: 'activity', name: tr('Bici lungo il Tejo', 'Bike ride along the Tagus'), cost: 12, multipleOption: 'B', notes: tr("Se c'è il sole", "If it's sunny") },
                            { time: '19:00', type: 'food', name: 'Time Out Market', cost: 20 },
                        ],
                    },
                ],
            },
            {
                name: 'Sintra',
                hotel: {
                    name: 'Quinta Verde B&B',
                    address: 'Sintra',
                    rating: 4.8,
                    price: 110,
                    notes: tr('Parcheggio gratuito', 'Free parking'),
                    mapsLink: maps('Sintra'),
                },
                days: [
                    {
                        date: '2027-05-15',
                        activities: [
                            { time: '08:15', timeS: '08:15', timeE: '08:55', type: 'transport', name: tr('Treno Rossio → Sintra', 'Train Rossio → Sintra'), from: 'Lisboa Rossio', to: 'Sintra', distance: 28, cost: 3, notes: tr('Ogni 20 minuti', 'Every 20 minutes') },
                            { time: '09:30', type: 'activity', name: 'Palácio da Pena', cost: 20, notes: tr('Bus 434 dalla stazione', 'Bus 434 from the station') },
                            { time: '13:00', type: 'food', name: tr('Travesseiros alla Piriquita', 'Travesseiros at Piriquita'), cost: 8 },
                            { time: '15:00', type: 'activity', name: 'Quinta da Regaleira', cost: 15, notes: tr('Il pozzo iniziatico', 'The initiation well') },
                        ],
                    },
                ],
            },
            {
                name: 'Porto',
                hotel: {
                    name: 'Ribeira Loft',
                    address: 'Ribeira, Porto',
                    rating: 4.5,
                    price: 88,
                    notes: tr('Vista sul Douro', 'Douro river view'),
                    mapsLink: maps('Ribeira Porto'),
                },
                days: [
                    {
                        date: '2027-05-16',
                        activities: [
                            { time: '09:09', timeS: '09:09', timeE: '11:58', type: 'transport', name: 'Alfa Pendular Lisboa → Porto', from: 'Lisboa Oriente', to: 'Porto Campanhã', distance: 313, cost: 32, notes: tr('Posti prenotati in carrozza 4', 'Seats booked in coach 4') },
                            { time: '14:00', type: 'activity', name: 'Livraria Lello', cost: 10, notes: tr('Il voucher si scala da un libro', 'The voucher counts towards a book') },
                            { time: '17:30', type: 'activity', name: tr('Ponte Dom Luís I al tramonto', 'Dom Luís I bridge at sunset'), cost: 0 },
                            { time: '20:00', type: 'food', name: tr('Francesinha a Ribeira', 'Francesinha in Ribeira'), cost: 18 },
                        ],
                    },
                    {
                        date: '2027-05-17',
                        activities: [
                            { time: '10:30', type: 'activity', name: tr('Degustazione nelle cantine di Gaia', 'Port tasting in Gaia cellars'), cost: 22 },
                            { time: '16:00', timeS: '16:00', timeE: '16:30', type: 'transport', name: tr("Metro per l'aeroporto", 'Metro to the airport'), from: 'Trindade', to: 'Aeroporto Francisco Sá Carneiro', distance: 15, cost: 2, notes: tr('Linea viola', 'Purple line') },
                        ],
                    },
                ],
            },
        ],
        mapData: {
            center: [38.7060, -9.1700],
            markers: [
                { position: [38.7139, -9.1335], label: 'Castelo de São Jorge' },
                { position: [38.7115, -9.1300], label: 'Casa Alfama Guesthouse' },
                { position: [38.6979, -9.2068], label: 'Mosteiro dos Jerónimos' },
                { position: [38.6916, -9.2160], label: 'Torre de Belém' },
                { position: [38.7036, -9.1786], label: 'LX Factory' },
                { position: [38.7071, -9.1458], label: 'Time Out Market' },
                { position: [38.7876, -9.3906], label: 'Palácio da Pena' },
                { position: [41.1466, -8.6115], label: 'Livraria Lello' },
            ],
            routes: [
                [[38.7115, -9.1300], [38.7139, -9.1335], [38.7071, -9.1458], [38.7036, -9.1786], [38.6979, -9.2068], [38.6916, -9.2160]],
            ],
        },
        places: {
            hotels: [
                { name: 'Casa Alfama Guesthouse', address: 'Alfama, Lisboa', zone: 'Lisboa', rating: 4.6, price: 92, mapsLink: maps('Alfama Lisboa') },
                { name: 'Quinta Verde B&B', address: 'Sintra', zone: 'Sintra', rating: 4.8, price: 110, mapsLink: maps('Sintra') },
                { name: 'Ribeira Loft', address: 'Ribeira, Porto', zone: 'Porto', rating: 4.5, price: 88, mapsLink: maps('Ribeira Porto') },
            ],
            restaurants: [
                { name: 'Pastéis de Belém', zone: 'Lisboa', specialty: 'Pastel de nata', hours: '08:00–23:00', price: 6, mapsLink: maps('Pastéis de Belém') },
                { name: 'Time Out Market', zone: 'Lisboa', specialty: tr('Street food portoghese', 'Portuguese street food'), hours: '10:00–24:00', price: 20, mapsLink: maps('Time Out Market Lisboa') },
                { name: 'Piriquita', zone: 'Sintra', specialty: 'Travesseiros', hours: '08:00–20:00', price: 8, mapsLink: maps('Piriquita Sintra') },
            ],
            attractions: [
                { name: 'Castelo de São Jorge', zone: 'Lisboa', hours: '09:00–21:00', price: 15, link: 'https://castelodesaojorge.pt/', mapsLink: maps('Castelo de São Jorge') },
                { name: 'Palácio da Pena', zone: 'Sintra', hours: '09:30–18:30', price: 20, mapsLink: maps('Palácio da Pena') },
                { name: 'Livraria Lello', zone: 'Porto', hours: '09:00–19:00', price: 10, mapsLink: maps('Livraria Lello') },
            ],
        },
        todos: [
            { title: tr('Prenotare Alfa Pendular Lisboa → Porto', 'Book Alfa Pendular Lisboa → Porto'), note: tr('Tariffa promo fino a 30 giorni prima', 'Promo fares up to 30 days ahead') },
            { title: tr('Biglietti Palácio da Pena', 'Palácio da Pena tickets'), note: tr('Fascia oraria 09:30', '09:30 time slot') },
            { title: tr('Ricaricare la Viva Viagem', 'Top up the Viva Viagem card') },
            { title: tr('Dividere le spese del B&B', 'Split the B&B costs'), note: tr('Giulia ha anticipato', 'Giulia paid upfront') },
        ],
        utilsLinks: [
            { title: 'Comboios de Portugal', summary: tr('Orari e biglietti dei treni', 'Train timetables and tickets'), url: 'https://www.cp.pt/' },
            { title: 'Metro de Lisboa', summary: tr('Mappa della metro', 'Metro map'), url: 'https://www.metrolisboa.pt/' },
        ],
    };
}

// Note condivise fittizie, chiavi `${city}_${dayIndex}_${activityIndex}` come in CityDetails.
export function buildDemoNotes(lang = 'it') {
    const tr = (it, en) => (lang === 'en' ? en : it);
    const at = (d, h) => `2027-04-${d}T${h}:00.000Z`;
    return {
        Lisboa_0_2: [
            { id: 'd1', author: 'Giulia', content: tr('Biglietti presi per tutti e 4 ✅', 'Got tickets for all 4 of us ✅'), createdAt: at('02', '18:12') },
            { id: 'd2', author: 'Marco', content: tr("Portate una felpa, la sera c'è vento", 'Bring a sweater, it gets windy at night'), createdAt: at('03', '09:40') },
        ],
        Lisboa_0_3: [
            { id: 'd3', author: 'Sara', content: tr('Prenotato alle 20:30, tavolo vicino al palco 🎶', 'Booked for 8:30pm, table near the stage 🎶'), createdAt: at('05', '21:03') },
        ],
        Lisboa_1_2: [
            { id: 'd4', author: 'Luca', content: tr('Ne prendo 12, non discutete', "I'm getting 12, no arguments"), createdAt: at('06', '12:30') },
        ],
        Sintra_0_1: [
            { id: 'd5', author: 'Giulia', content: tr("Meglio arrivare prima delle 10, poi c'è coda", 'Get there before 10, then the queue builds up'), createdAt: at('08', '08:15') },
        ],
    };
}
